import moment from 'moment';
import CookieHelper from './OldCookieHelper';
import CurrencyHelper from './CurrencyHelper';
import OldErrorHandlerHelper from './OldErrorHandlerHelper';
import OldSessionStorageHelper from './OldSessionStorageHelper';
import config from '../../config';

class OldFormatHelper {
  currencies = {};
  loaded = false;

  constructor() {
    this.setCurrencies();
  }

  /**
   * formats time values to include a leading 0 if the value is < 10
   * @param { Number|String } value
   * @param { String } type - minute or second
   *
   * @return {number} formattedValue
   */
  formatTimeValue(value, type) {
    let formattedValue = value;
    switch(type) {
      case `minute`:
        // eslint-disable-next-line no-case-declarations
        let minutes = Math.floor((formattedValue % (1000 * 60 * 60)) / (1000 * 60));
        if(minutes < 10) {
          minutes = `0${minutes}`;
        }
        formattedValue = minutes;
        break;
      case `second`:
        // eslint-disable-next-line no-case-declarations
        let seconds = Math.floor((formattedValue % (1000 * 60)) / 1000);
        if(seconds < 10) {
          seconds = `0${seconds}`;
        }
        formattedValue = seconds;
        break;
      default:
    }
    return formattedValue;
  }

  format(num, digits = 2) {
    if(typeof num !== `number`) {
      return ``;
    }
    return num.toLocaleString(CookieHelper.getLanguage(), { minimumFractionDigits: digits });
  }

  getPrice(price, currency = null) {
    let internalCurrency = currency;
    let internalPrice = price;

    if(!internalCurrency) {
      internalCurrency = CookieHelper.getCurrency();
    }
    if(!internalPrice) {
      internalPrice = 0;
    }

    return `${this.getCurrencySymbol(internalCurrency)} ${internalPrice.toFixed(2).replace(`.`, `,`)}`;
  }

  formatAddressCity(address) {
    const temp = [];
    if(address.zipCode) temp.push(address.zipCode);
    if(address.city) temp.push(address.city);
    return temp.join(` `);
  }

  formatAddressStreet(address) {
    const temp = [];
    if(address.street) temp.push(address.street);
    if(address.streetNumber) temp.push(address.streetNumber);
    return temp.join(` `);
  }

  formatDeliveryTypeName(deliveryType, currency) {
    const price = this.getPrice(deliveryType.cost, currency);

    const deliveryItems = [deliveryType.name, deliveryType.service, price].filter(item => item?.trim() ?? false);

    const last = deliveryItems.pop();
    return `${deliveryItems.join(`, `)} ${last}`;
  }

  formatPhoneType(type) {
    switch(type) {
      case 1:
        return `landline`;
      case 2:
        return `mobile`;
      case 3:
        return `fax`;
      default:
        OldErrorHandlerHelper.handleError(`Phone ${type} unknown!`, { logToConsole: true });
        return ``;
    }
  }

  formatFullAddress(address, cartTypeId = null) {
    if(!address) {
      OldErrorHandlerHelper.handleError(`Error converting address. No address given`, { logToConsole: true });
      return ``;
    }
    switch(cartTypeId) {
      case 1:
        return window.vueHeader.cartSelectTexts.own;
      case 3:
        return window.vueHeader.cartSelectTexts.merchandise;
      default:
        return `${address.recipient}, ${this.formatAddressStreet(address)}, ${this.formatAddressCity(address)} - ${address.country}`;
    }
  }

  getCurrencySymbol(_currency) {
    const currency = _currency.toUpperCase();
    if(!this.loaded) {
      // ErrorHandlerHelper.handleError(`currencies not loaded yet!`, { logToConsole: true });
      return ``;
    }
    if(typeof this.currencies[currency] === `undefined`) {
      OldErrorHandlerHelper.handleError(`unknown currency: ${currency}`, { logToConsole: true });
      return ``;
    }

    return this.currencies[currency].symbol;
  }

  async setCurrencies() {
    if(this.loaded) {
      return;
    }

    let currencies = OldSessionStorageHelper.getCurrencyList();

    if(!currencies) {
      // fallback until we fetched the currencies from php or made the display reactive
      this.currencies.EUR = {
        euroExchangeRate: 1,
        iso: `EUR`,
        symbol: `€`,
      };
      currencies = await CurrencyHelper.fetchCurrencies();
    }

    for(const currency of currencies) {
      this.currencies[currency.iso] = currency;
    }
    this.loaded = true;
  }

  getTimestamp(date) {
    if(!date) {
      return null;
    }
    return parseInt(moment(date, `DD.MM.YYYY`).format(`X`), 10);
  }

  timestampToDateFormat(date, format = `DD.MM.YYYY`) {
    return moment(date).format(format);
  }

  formatPercentages(percentage) {
    return `${percentage}%`;
  }

  percentageClass(percentage) {
    if(percentage > 0) {
      return `value--positive`;
    }
    if(percentage < 0) {
      return `value--negative`;
    }
    return null; // exactly 0
  }

  getFiltersFetchConfig(filters) {
    let ret = [];

    for(const filter of Object.keys(filters)) {
      // eslint-disable-next-line no-prototype-builtins
      if(filters.hasOwnProperty(filter) && filters[filter]) {
        ret = [...ret, `${filter}=${filters[filter]}`];
      }
    }

    return ret.length > 0 ? `/?${ret.join(`&`)}` : ``;
  }

  replaceUnicodeChars(text) {
    let cleanText = text;

    for(const uniCode of config.unicodes) {
      if(cleanText.includes(uniCode.code)) {
        cleanText = cleanText.replaceAll(uniCode.code, uniCode.replacement);
      }
    }

    return cleanText;
  }
}

export default new OldFormatHelper();
